import React from "react";
import { Space } from "antd";
import { GeoAltFill, TelephoneFill, EnvelopeAtFill, Globe } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Footer = function Footer() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        background: "#D8C0C0",
        textAlign: "center",
        padding: "7px",
        borderRadius: "7px",
        color: "#433F3F"
      },
      children: [/*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(GeoAltFill, {
          size: 29
        }), /*#__PURE__*/_jsx("span", {
          children: " Adresse: Kissidougou, Korodou, Secteur II - Route Nationale N\xB01"
        }), /*#__PURE__*/_jsx(TelephoneFill, {
          size: 29
        }), /*#__PURE__*/_jsx("span", {
          children: " 622342787/621128638"
        })]
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(EnvelopeAtFill, {
          size: 29
        }), /*#__PURE__*/_jsx("span", {
          children: " info@cliniqueinterkissidougou.com"
        }), /*#__PURE__*/_jsx(Globe, {
          size: 29
        }), /*#__PURE__*/_jsx("span", {
          children: " www.cliniqueinterkissidougou.com"
        })]
      })]
    })
  });
};
export default Footer;